// @flow
import React from 'react';
import styled from '@emotion/styled';
import { FixedSizeList as List } from 'react-window';
import AutoSizer from 'react-virtualized-auto-sizer';

import { TableRow, TableCell } from './Table';
import TableHead from './TableHead';

type Props = {
  players: Array<Object>
};

const header = [
  {
    field: 'insiderName',
    label: 'Name',
    size: 7,
    sortable: false
  },
  {
    field: 'insiderScoreUpdated',
    label: 'Projection',
    size: 2,
    sortable: false
  },
  {
    field: 'insiderExposure',
    label: 'Exposure%',
    size: 3,
    sortable: false
  }
];

const Wrapper = styled.div(({ theme }) => ({
  marginBottom: theme.spacing.small
}));

const LineUpsExposureTable = ({ players }: Props) => {
  const Row = ({ index, style }: RowProps) => {
    const { idStr, name, exposure, insiderScoreUpdated } = players[index];

    return (
      <TableRow key={idStr} style={style}>
        <TableCell className="is-7">{name}</TableCell>
        <TableCell className="is-2">{insiderScoreUpdated}</TableCell>
        <TableCell className="is-2">{exposure}%</TableCell>
      </TableRow>
    );
  };

  return (
    <Wrapper>
      <TableHead columns={header} hasScrollbar />
      <div style={{ flex: '1 1 auto' }}>
        <AutoSizer disableHeight>
          {({ width }) => (
            <List height={600} itemCount={players.length} itemSize={40} width={width}>
              {Row}
            </List>
          )}
        </AutoSizer>
      </div>
    </Wrapper>
  );
};

export default React.memo(LineUpsExposureTable);
